import React, { useState, useEffect, useRef } from "react";
import "./gallery.css";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
const featuredImages = [
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Front.jpg",
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Rear-3qtr.jpg",
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Front-3qtr.jpg",
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Top-Front-3qtr.jpg",
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Rear.jpg",
  "https://cdn.pmlsound.com/anthem/avm90/images/AVM90_Gallery/AVM90-Lifestyle-3.jpg",
];
let count = 0;
let slideInterval;
const Gallery = () => {
  const slideRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);

  const pauseSlider = () => {
    clearInterval(slideInterval);
  };

  const removeAnimation = () => {
    // slideRef.current.classList.remove("fade-anim");
  };
  const startSlider = () => {
    slideInterval = setInterval(() => {
      handleOnNextClick();
    }, 4000);
  };

  useEffect(() => {
    startSlider();
    // slideRef.current.addEventListener("animationend", removeAnimation);
    slideRef.current.addEventListener("mouseenter", pauseSlider);
    slideRef.current.addEventListener("mouseleave", startSlider);

    return () => {
      clearInterval(slideInterval);
    };
  }, []);

  const handleOnNextClick = () => {
    count = (count + 1) % featuredImages.length;
    setCurrentIndex(count);
    // slideRef.current.classList.add("fade-anim");
  };

  const handleOnPrevClick = () => {
    const productsLength = featuredImages.length;
    count = (currentIndex + productsLength - 1) % productsLength;
    setCurrentIndex(count);
    // slideRef.current.classList.add("fade-anim");
  };
  return (
    <section className="bg-black z-50 relative " id="gallery">
      <div className="max-w-7xl m-auto leading-normal tracking-normal">
        <div className="w-full relative select-none" ref={slideRef}>
          <div className="aspect-w-16 aspect-h-11">
            <img src={featuredImages[currentIndex]} alt="" />
          </div>

          <div className="absolute w-full top-1/2 transform -translate-y-1/2  flex justify-between items-start px-8 ">
            <button
              onClick={handleOnPrevClick}
              className="bg-black text-white p-1 rounded-full bg-opacity-50 cursor-pointer hover:bg-opacity-100 transition"
            >
              <ChevronLeftIcon
                className="text-white h-6 w-6 "
                aria-hidden="true"
              />
            </button>
            <button
              onClick={handleOnNextClick}
              className="bg-black text-white p-1 rounded-full bg-opacity-50 cursor-pointer hover:bg-opacity-100 transition"
            >
              <ChevronRightIcon
                className="text-white h-6 w-6 "
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
